export default __webpack_public_path__ + "static/media/healthcare.6ae177af.jpeg";